export default function(instance) {
  return {
    getAllVotings() {
      return instance.get("/api/voting/votings/");
    },
    createVoting(data) {
      return instance.post("/api/voting/votings/", data);
    },
    closeVoting(id, data) {
      return instance.post(`/api/voting/votings/close/${id}/`, {
        result: data.result,
        solution: data.solution
      });
    },
    deleteVoting(id) {
      return instance.delete(`/api/voting/votings/admin/${id}/`);
    }
  };
}
